module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_7_4.1d8ad7f6.png";